export enum WeekDay {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}

export enum WeekDayRus {
    Воскресенье,
    Понедельник,
    Вторник,
    Среда,
    Четверг,
    Пятница,
    Суббота,
}

export enum WeekDayRusShort {
    вс,
    пн,
    вт,
    ср,
    чт,
    пт,
    сб,
}